import React from 'react';
import { ListNavigationBack } from '@weezevent/throne';
import { Icon } from '@weezevent/nacre';
import css from './seat-map.module.css';

function BackButton({ name, onBack }) {
    return (
        <div className={css['back-button-title']}>
            <ListNavigationBack onClick={onBack}>
                <Icon circular={false} className={css['back-button-chevron']} inverted={false} margin name="chevron-left" size="regular" />
            </ListNavigationBack>
            <span className="availability-zone-name">{name}</span>
        </div>
    );
}
export default BackButton;
